module.exports = __webpack_public_path__ + "img/pick_up_heading.13ac7a31.png";